import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ExploreTab } from '~/store/useExploreTabStore';

interface TabProps {
  activeTab: ExploreTab;
  setActiveTab: (state: ExploreTab) => void;
}

export default function Tab({ activeTab, setActiveTab }: TabProps) {
  return (
    <Container>
      <TabList
        isActive={activeTab === 'popular'}
        onClick={() => setActiveTab('popular')}
      >
        <button>Popular</button>
      </TabList>
      <TabList
        isActive={activeTab === 'latest'}
        onClick={() => setActiveTab('latest')}
      >
        <button>Latest</button>
      </TabList>
    </Container>
  );
}

const Container = styled.ul`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px;
    border: 1px solid ${theme.stroke.stroke_1};
    border-radius: 23px;
    gap: 4px;
  `}
`;

const TabList = styled.li<{ isActive: boolean }>`
  ${({ theme, isActive }) => css`
    flex: 1;
    border: 1px solid
      ${isActive ? theme.backgroundColor.bg_light_1 : theme.stroke.stroke_1};
    border-radius: 19px;
    background: ${isActive ? theme.backgroundColor.bg_light_1 : 'transparent'};

    & > button {
      display: block;
      width: 100%;
      height: 36px;
      ${theme.fontStyle.text.body16_bold}
      color: ${isActive
        ? theme.content.content_dark_1
        : theme.content.content_light_3};
    }
  `}
`;
